import React from 'react'
import { Badge } from '../ui/badge'
import { useTranslation } from 'react-i18next'

export default function NewBadge() {
    const { t } = useTranslation()
    return (
        <Badge className="text-[10px] bg-blue-100 text-blue-800 border-blue-100 hover:bg-blue-100 hover:text-blue-800">
            {t('general.new')}
        </Badge>
    )
}
